import React, { useEffect, useState } from "react";
import {
    Button,
    Col,
    Container,
    Row,
    Card,
    CardBody,
    Input,
    CardHeader,
    Table,
    ModalHeader,
    ModalBody,
    Modal,
    Progress,
    Nav,
    NavItem,
    NavLink,
} from "reactstrap";
import Breadcrumbs from "../../../Components/Common/BreadCrumbs";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import classnames from "classnames";
import { Link } from "feather-icons-react/build/IconComponents";
const EmployeeDisplay = (props) => {
    // const navigate = useNavigate();
    const location = useLocation();

    const { id } = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const navigate = useNavigate();
    const [activeTab, setactiveTab] = useState(1);
    const [passedSteps, setPassedSteps] = useState([1]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [progressbarvalue, setprogressbarvalue] = useState(0);
    const openModal = () => {
        setIsModalOpen(true);


    };

    function toggleTab(tab, value) {
        if (activeTab !== tab) {
            var modifiedSteps = [...passedSteps, tab];

            if (tab >= 1 && tab <= 4) {
                setactiveTab(tab);
                setPassedSteps(modifiedSteps);
            }
        }
        setprogressbarvalue(value);
    }


    const options = [
        { image: "/COPO.jpg", label: "COPO MIS" },
        { image: "/Goaml.jpg", label: "CIB" },
        { image: "/Goaml.jpg", label: "GO-AML" },
        { image: "/NEFSCUN.jpg", label: "NEFSCUN" },
        { image: "/DistrictCoop.jpg", label: "District COOP Reporting" },
        {
            image: "/DistrictCoop.jpg",
            label: "Municipality Cooperative Department",
        },
        { image: "/DistrictCoop.jpg", label: "Provincial Cooperative Department" },
    ];
    const getLabelText = (step) => {
        switch (step) {
            case 1:
                return "New report";
            case 2:
                return "Drafted";
            case 3:
                return "Initiated";
            case 4:
                return "Submitted";
            case 5:
                return "Acknowedged";
            case 6:
                return "Approved";
            default:
                return "";
        }
    };
    const breadcrumbItems = [
        { title: "Reports", link: "#" },
        { title: "Create New Report" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                {/* <div className="justify-content-between">
           </div> */}
                <Container fluid>
                    <Row>
                        <Col>
                        <Breadcrumbs items={breadcrumbItems} />

                            <Row className="">
                                {/* Column for Import Excel File and Clear Data buttons */}
                                <Col lg={6}>
                                    <Row>
                                        <Col lg={4}>
                                            {/* <Button block className="ms-2 btn-primary">Import Excel File</Button> */}
                                            <Button
                                                block
                                                outline
                                                size="lg"
                                                color="primary"
                                                className="btn  waves-effect w-100 "
                                            >
                                                Delete
                                            </Button>
                                        </Col>
                                        <Col lg={4} className="d-flex ">
                                            <Button
                                                block
                                                outline
                                                size="lg"
                                                color="primary"
                                                className="btn  w-100 ms-1"
                                            >
                                                Clear Data
                                            </Button>
                                        </Col>
                                        <Col lg={4} className="d-flex ">
                                            <Button
                                                block
                                                outline
                                                size="lg"
                                                color="primary"
                                                className="btn waves-effect w-100 ms-1"
                                            >
                                                Save as PDF
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg={6}>
                                    <Row>
                                        <div className="d-flex justify-content-end gap-2">
                                            <Button
                                                outline
                                                size="lg"
                                                color="danger"
                                                className="btn waves-effect"
                                                style={{ width: "25%" }}
                                            >
                                                Save as Draft
                                            </Button>

                                            <Button
                                                outline
                                                size="lg"
                                                color="info"
                                                onClick={openModal}
                                                className="btn"
                                                style={{ width: "25%" }}

                                            >
                                                Submit
                                            </Button>

                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Row className="px-2">
                                        <Col lg={6}>
                                            <Row>
                                                <Card className="mt-2">
                                                    <CardBody className="mt-2">
                                                        <h6 className="fw-bold">
                                                            Your submission no:: 800058228983
                                                        </h6>

                                                        <div className="card-width-full">
                                                            <div className="d-flex">
                                                                <div className="mt-2 me-3 col">
                                                                    <p className="mb-2">Report name</p>
                                                                    <Input
                                                                        className="form-control"
                                                                        placeholder="Your Report Name"
                                                                    />
                                                                </div>
                                                                <div className="mt-2 me-3 col">
                                                                    <p className="mb-2">Report Type</p>
                                                                    <Input
                                                                        className="form-control"
                                                                        placeholder="...Select Year..."
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="py-1">
                                                            <div className="d-flex">
                                                                <div className="mt-2 me-3 col">
                                                                    <p className="mb-2">Year</p>
                                                                    <Input
                                                                        className="form-control"
                                                                        placeholder="...Select Year..."
                                                                    />
                                                                </div>
                                                                <div className="mt-2 me-3 col">
                                                                    <p className="mb-2">Month</p>
                                                                    <Input
                                                                        className="form-control"
                                                                        placeholder="...Select Month..."
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Row>
                                        </Col>
                                        <Col lg={6}>
                                            <Row className="ms-1 ">
                                                <Card className="mt-2">
                                                    <CardHeader className="py-3">
                                                        <div className="d-flex justify-content-center ">
                                                            <h6 className="">Report Status</h6>
                                                        </div>
                                                    </CardHeader>
                                                    <CardBody className="progress-nav py-5">
                                                        <div className="progress-nav ">
                                                            {/* Add a larger border to the timeline and set it to success color */}

                                                            <Progress
                                                                value={progressbarvalue}
                                                                style={{ height: "1px" }}
                                                            />

                                                            <Nav
                                                                className="nav-pills progress-bar-tab custom-nav "
                                                                role="tablist"
                                                            >
                                                                {[1, 2, 3, 4, 5, 6].map((step) => (
                                                                    <NavItem key={step}>
                                                                        <NavLink
                                                                            to="#"
                                                                            id={`pills-gen-info-tab-${step}`}
                                                                            className={classnames(
                                                                                {
                                                                                    active: activeTab === step,
                                                                                    done:
                                                                                        activeTab <= 6 && activeTab >= 0,
                                                                                },
                                                                                "rounded-pill",
                                                                                "success" // Add success color class
                                                                            )}
                                                                            onClick={() => {
                                                                                toggleTab(step, ((step - 1) * 100) / 6);
                                                                            }}
                                                                            tag="button"
                                                                        >
                                                                            {step}
                                                                        </NavLink>
                                                                        {/* <div className="mt-3 text-center">
                                      {" "}
                                   
                                      {getLabelText(step)}
                                    </div> */}
                                                                    </NavItem>
                                                                ))}
                                                            </Nav>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row >
                                        <Card className="p-0">
                                            <CardBody className="pt-1">
                                                <div className="table-responsive table-card mt-1 w-full">
                                                    <Table className="table align-middle table-nowrap">
                                                        <thead style={{ backgroundColor: "#e5edf6" }}>
                                                            <tr className="text-muted">
                                                                <td>
                                                                    H.No 10 share Capital Accounting
                                                                    Account(Schedule-1)
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                    </Table>
                                                </div>

                                                <div className="table-responsive table-card mt-1  w-full">
                                                    <Table className="table align-middle table-nowrap">
                                                        <thead className="table-light">
                                                            <tr className="text-muted">
                                                                <td>S.N</td>
                                                                <td>DESCRIPTION</td>
                                                                <td className="text-center">CREDIT</td>{" "}
                                                                <td className="text-center">DEBIT</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        01
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Sharing accounting accounts
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`Rs. 51,512600.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span></span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Total
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`Rs. 51,512600.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>

                                                <div className="table-responsive table-card  w-full">
                                                    <Table className="table align-middle table-nowrap">
                                                        <thead style={{ backgroundColor: "#e5edf6" }}>
                                                            <tr>
                                                                <td>
                                                                    H.No 10 share Capital Accounting
                                                                    Account(Schedule-2)
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                    </Table>
                                                </div>

                                                <div className="table-responsive table-card mt-1  w-full">
                                                    <Table className="table align-middle table-nowrap">
                                                        <thead className="table-light">
                                                            <tr className="text-muted">
                                                                <td>S.N</td>
                                                                <td>DESCRIPTION</td>
                                                                <td className="text-center">CREDIT</td>{" "}
                                                                <td className="text-center">DEBIT</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr >
                                                                <td
                                                                    className="table-light fw-bold"
                                                                    colSpan="12"
                                                                    style={{ marginBottom: "10px" }}
                                                                >
                                                                    Reverse fund
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        01
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Sharing accounting accounts
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`Rs. 28,5275300.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="form table-light fw-bold" colSpan="12">
                                                                    Other funds
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        02
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Share dividend fund accounting account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        03
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Protected capital fund accounting account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        04
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Employee bonus fund accounting account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        05
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Cooperative education fund accounting account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        06
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Cooperative development fund account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        07
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Deflict fund account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        08
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Cooperative mnagement fund accounts
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        09
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Balance sheet account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        10
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Community development fund account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`Rs. 93,500.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        11
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Other risk management fund accounts
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span></span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Total
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`Rs. 28,368,801.83`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                <div className="table-responsive table-card  w-full">
                                                    <Table className="table align-middle table-nowrap">
                                                        <thead style={{ backgroundColor: "#e5edf6" }}>
                                                            <tr className="text-muted">
                                                                <td>
                                                                    H.No 10 share Capital Accounting
                                                                    Account(Schedule-3)
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                    </Table>
                                                </div>

                                                <div className="table-responsive table-card mt-1  w-full">
                                                    <Table className="table align-middle table-nowrap">
                                                        <thead className="table-light">
                                                            <tr className="text muted">
                                                                <td>S.N</td>
                                                                <td>DESCRIPTION</td>
                                                                <td className="text-center">CREDIT</td>{" "}
                                                                <td className="text-center">DEBIT</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        01
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Stabialization fund(in case of union only)
                                                                        account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        02
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Debt protection fund account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`Rs. 2,712,67464.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        03
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Undistributed net cash account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span
                                                                        className="form-control border-0"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        04
                                                                    </span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        member relief fund account
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`0.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <span></span>
                                                                </td>
                                                                <td className="col-sm-5">
                                                                    <span
                                                                        className="form-control border-0 fw-bold"
                                                                        style={{ backgroundColor: "#f8f9fa" }}
                                                                    >
                                                                        Total
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <input type="number" className="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control text-end"
                                                                        value={`Rs. 2,712,67464.00`}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </CardBody>
                                            <Row style={{ backgroundColor: "" }}>
                                                {/* Column for Import Excel File and Clear Data buttons */}
                                                <Col lg={6}>
                                                    <Row>
                                                        <Col lg={4}>
                                                            {/* <Button block className="ms-2 btn-primary">Import Excel File</Button> */}
                                                            <Button
                                                                block
                                                                outline
                                                                size="lg"
                                                                color="primary"
                                                                className="btn  waves-effect w-100 "
                                                            >
                                                                Delete
                                                            </Button>
                                                        </Col>
                                                        <Col lg={4} className="d-flex ">
                                                            <Button
                                                                block
                                                                outline
                                                                size="lg"
                                                                color="primary"
                                                                className="btn  w-100 ms-1"
                                                            >
                                                                Clear Data
                                                            </Button>
                                                        </Col>
                                                        <Col lg={4} className="d-flex ">
                                                            <Button
                                                                block
                                                                outline
                                                                size="lg"
                                                                color="primary"
                                                                className="btn waves-effect w-100 ms-1"
                                                            >
                                                                Save as PDF
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col lg={6}>
                                                    <Row>
                                                        <div className="d-flex justify-content-end gap-2">
                                                            <Button
                                                                outline
                                                                size="lg"
                                                                color="danger"
                                                                className="btn waves-effect"
                                                                style={{ width: "25%" }}
                                                            >
                                                                Save as Draft
                                                            </Button>
                                                            <Button
                                                                outline
                                                                size="lg"
                                                                color="info"
                                                                className="btn"
                                                                onClick={openModal}
                                                                style={{ width: "25%" }}
                                                            >
                                                                Submit
                                                            </Button>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Card>


                                    </Row>
                                </Col>


                            </Row>
                            <Modal
                                size={"lg"}
                                isOpen={isModalOpen}
                                toggle={() => setIsModalOpen(!isModalOpen)}
                            >
                                <ModalHeader
                                    toggle={() => setIsModalOpen(!isModalOpen)}
                                    className="text-center"
                                ></ModalHeader>
                                <ModalBody>
                                    <Container>
                                        <Row>
                                            <Col xs={12} className="text-center ">
                                                <p>
                                                    <strong>
                                                        Select affiliated organization to submit report
                                                    </strong>
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row className="justify-content-center mt-2">
                                            {options.map((option, index) => (
                                                <Col
                                                    xs={6}
                                                    md={3}
                                                    key={index}
                                                    className="text-center mb-3"
                                                >
                                                    <div
                                                        className="position-relative image-container px-auto border rounded"
                                                        style={{ borderWidth: "3px", height: "100%" }}
                                                    >
                                                        <div className="mt-2">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input form-check-success position-absolute end-0 top-0 mt-2 me-2"
                                                                id={`image${index + 1}`}
                                                            />
                                                            <label
                                                                className="form-check-label mb-3"
                                                                htmlFor={`image${index + 1}`}
                                                            ></label>
                                                        </div>
                                                        <div className="img-container mt-2">
                                                            <img
                                                                src={option.image}
                                                                className="img-fluid rounded"
                                                                alt={`Option ${index + 1}`}
                                                                style={{
                                                                    width: "50%",
                                                                    height: "auto",
                                                                    margin: "auto",
                                                                }}
                                                            />
                                                            <div className="text-below-image mt-2 px-2">
                                                                <p>{index === 0 ? "COPO MIS" : option.label}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>

                                        <Row className="d-flex justify-content-center mt-2">
                                            <Col>
                                                <div className="d-flex justify-content-center">

                                                    <Button className="btn btn-info waves btn-submit-report w-50"
                                                        onClick={() => window.location.href = `/report-waiting-acck`}>
                                                        Submit report
                                                    </Button>

                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </ModalBody>
                            </Modal>



                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default EmployeeDisplay;
